module.exports = __webpack_public_path__ + "img/icon_choice_seleceted.6d97eb12.svg";